// extracted by mini-css-extract-plugin
module.exports = {"editFloorIcon":"ChangeFloorName_editFloorIcon__2dpXg"};